import React from 'react';

const Footer = ({ logo }) => {
  return (
    <footer className="amazon-footer">
      <div className="footer-content">
        <div className="footer-brand">
          {logo && <img src={logo} alt="Awesome PDF Tools" />}
          <span className="footer-copyright">Awesome PDF Tools — client-side PDF toolkit</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
